module.exports = __webpack_public_path__ + "media/images/fresh-groceries-0e6abc0d.png";